import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Skeleton } from '..';
const FlagIcon = _ref => {
  let {
    url,
    name,
    type,
    className,
    loading
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames('flag-wrap', className)
  }, loading ? /*#__PURE__*/React.createElement(Skeleton, {
    type: "circle",
    className: "medium"
  }) : url ? /*#__PURE__*/React.createElement("span", {
    className: "img-placeholder",
    style: {
      backgroundImage: `url(${url})`
    }
  }) : /*#__PURE__*/React.createElement("span", {
    className: `${type} ${type}-${name || 'placeholder'}`
  }));
};
FlagIcon.propTypes = {
  url: PropTypes.string,
  name: PropTypes.string,
  type: PropTypes.string,
  className: PropTypes.string,
  loading: PropTypes.bool
};
FlagIcon.defaultProps = {
  type: 'flag',
  className: ''
};
export default /*#__PURE__*/memo(FlagIcon);